import { useEffect } from 'react';
import { useAuthContext } from '../../auth/authContext';
import { useIntercomJwtQuery } from '../api/queries/useIntercomJwtQuery';
import { clearIntercomJwt, isJwtUsable } from '../utils/intercomJwtCache';

export const useIntercomUserInfo = () => {
  const { isLoggedIn } = useAuthContext();
  const { data: token, refreshJwt } = useIntercomJwtQuery();

  useEffect(() => {
    if (!isLoggedIn) {
      void clearIntercomJwt();
    }
  }, [isLoggedIn]);

  const isReady = !isLoggedIn ? true : !!token && isJwtUsable(token);

  return {
    user: token ? { intercom_user_jwt: token, session_duration: 86400 } : null,
    isReady,
    refreshJwt: async () => (await refreshJwt()) ?? null,
  };
};
